export const AppStateInitialState: AppStateTypes = {
  activeGroupId: null,
  userSelectedPrograms: null,
  isLoading: false,
  settingsTimeoutId: null,
  programsListWSUpdates: [],
  notificationType: 'toast',
  progIdInFullScreen: '',
  notifications: [],
  highlightedDates: [],
};
